import React, { useEffect, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { orange } from "@material-ui/core/colors";
import InputMask from "react-input-mask";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import MaterialInput from "@material-ui/core/Input";
import {
  FormControl,
  InputLabel,
  FormHelperText,
  Input,
} from "@material-ui/core";
import "./ClientForm.css";

import { TextField } from "@material-ui/core";

const ColorButton = withStyles((theme) => ({
  root: {
    color: "white",
    backgroundColor: "#C34720",
    "&:hover": {
      backgroundColor: orange[900],
    },
  },
}))(Button);

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function validatePhone(phone: string) {
  const re = /(?<!\w)(\(?(\+|00)?48\)?)?[ -]?\d{3}[ -]?\d{3}[ -]?\d{3}(?!\w)/;
  return re.test(String(phone).toLocaleLowerCase());
}

function validateName(name: string) {
  return name.length > 3;
}

async function postData(url = "", data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  return response.json(); // parses JSON response into native JavaScript objects
}

function ClientForm(props: any) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [emailError, setEmailError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [client, setClient] = useState({} as any);

  let fetchUrl: string;
  // if (process.env.NODE_ENV === "development") {
  //   fetchUrl = `apisummary/`;
  // } else {
  //   fetchUrl = `http://127.0.0.1:8000/apisummary/`;
  // }
  fetchUrl = `http://127.0.0.1:8000/apisummary/`;

  const onSendHandle = () => {
    setIsLoading(true);
    const data = {
      ...client,
      drawing: props.drawing,
      konfigured: props.konfigured,
      price: props.price,
    };
    postData(fetchUrl, data).then(
      (result) => {
        setIsLoading(false);
        if (result === "ok") {
          props.handeSend(true);
        }
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        setIsLoading(true);
        setError(error);
      }
    );
  };
  return (
    <div className="ContClientForm">
      <h1>Contact</h1>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControl
            className={!nameError && client["client_name"] ? "success" : ""}
            error={nameError}
          >
            <InputLabel htmlFor="name">Name</InputLabel>
            <Input
              id="name"
              type="text"
              required
              name="client_name"
              value={client["client_name"]}
              onChange={(e) => {
                setNameError(!validateName(e.target.value));
                setClient({ ...client, [e.target.name]: [e.target.value] });
              }}
            />
            {/* <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText> */}
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl
            className={!emailError && client["client_email"] ? "success" : ""}
            error={emailError}
          >
            <InputLabel htmlFor="email">Email</InputLabel>
            <Input
              id="email"
              required
              name="client_email"
              value={client["client_email"]}
              aria-describedby="my-helper-text"
              onChange={(e) => {
                setEmailError(!validateEmail(e.target.value));
                setClient({ ...client, [e.target.name]: [e.target.value] });
              }}
            />
            {/* <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText> */}
          </FormControl>
          {/* <TextField
            name="client_email"
            required
            label="E-mail"
            type="email"
            helperText="Incorrect entry."
            value={client["client_email"]}
            // onChange={(e) => {
            //   setEmailError(validateEmail)
            //   setClient({ ...client, [e.target.name]: [e.target.value] });
            // }}
          /> */}
        </Grid>
        <Grid item xs={12}>
          <FormControl
            className={phoneError ? "" : "success"}
            error={phoneError}
          >
            <InputLabel htmlFor="phone">Phone</InputLabel>
            <InputMask
              value={client["phone"]}
              onChange={(e) => {
                setPhoneError(!validatePhone(e.target.value));
                setClient({ ...client, [e.target.name]: [e.target.value] });
              }}
              mask="+48 999 999 999"
              maskChar=" "
            >
              {() => (
                <Input
                  name="phone"
                  required
                  type="text"
                  value={client["phone"]}
                />
              )}
            </InputMask>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <div className="Contact-button-wrap">
            <ColorButton
              onClick={() => {
                onSendHandle();
              }}
              disabled={
                nameError ||
                emailError ||
                phoneError ||
                !client["client_email"] ||
                !client["client_name"] ||
                !client["phone"]
              }
              variant="contained"
              color="primary"
            >
              <span
                className="cubic-transition"
                style={{ opacity: isLoading ? "0" : "1" }}
              >
                {" "}
                Send
              </span>

              <div
                className="button-loader cubic-transition"
                style={{ opacity: isLoading ? "1" : "0" }}
              >
                <div className="white-small-ring sk-fading-circle">
                  <div className="sk-circle1 sk-circle"></div>
                  <div className="sk-circle2 sk-circle"></div>
                  <div className="sk-circle3 sk-circle"></div>
                  <div className="sk-circle4 sk-circle"></div>
                  <div className="sk-circle5 sk-circle"></div>
                  <div className="sk-circle6 sk-circle"></div>
                  <div className="sk-circle7 sk-circle"></div>
                  <div className="sk-circle8 sk-circle"></div>
                  <div className="sk-circle9 sk-circle"></div>
                  <div className="sk-circle10 sk-circle"></div>
                  <div className="sk-circle11 sk-circle"></div>
                  <div className="sk-circle12 sk-circle"></div>
                </div>
              </div>
            </ColorButton>
          </div>
        </Grid>
      </Grid>
      <div></div>
    </div>
  );
}

export default ClientForm;
